<div nz-row class="fehleingabe">
	<nz-alert *ngIf="fehlEingabe" class="big-warning text-center"
		nzType="warning" nzShowIcon
		nzMessage="{{ 'message.warning.falseReactionInput' | translate }}"
		nz-col nzSpan="24"
	></nz-alert>
</div>
<div class="center-content">
	<div class="marker"></div>
	<div class="hugeButton rotating" id="rotating-circle">
		<div class="tick-line"></div>
	</div>
</div>
<div class="extrabuttons buttonrow replaceButtonrow">
	<div class="left-buttons"></div>
	<div class="right-buttons">
		<!--Vorwärts für Seiten einzelner Fragen-->
		<button nz-button nzType="primary" class="big-button right-one" (touchstart)="dispatchVitaReact($event)" (mousedown)="dispatchVitaReact($event)">
			{{ buttonText | translate }}
		</button>
	</div>
</div>
